import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Sticky from 'react-stickynode';

// Images
import logo from '../../images/logo.png';
import logoWhite from '../../images/logo-white.png';

const Header = () => {
	
	const [isMenuOpen, setIsMenuOpen] = useState(false);
	const [isSearchFormOpen, setIsSearchBtn] = useState(false);
	const quikSearchBtn = () => setIsSearchBtn(!isSearchFormOpen);
	const quikSearchClose = () => setIsSearchBtn(false);
	const [activeItem, setActiveItem] = useState(null);
	const [isMobileView, setIsMobileView] = useState(false);
	
	const toggleSubmenu = (item) => {
		setActiveItem(item === activeItem ? null : item);
	};
	
	const toggleMenu = () => {
		setIsMenuOpen((prev) => !prev);
	};

	const handleMenuLinkClick = () => {
		if (window.innerWidth <= 991) {
			setIsMenuOpen(false);
		}
	};

	const handleContactBtnClick = () => {
		setIsMenuOpen(false);
		// Implement the logic to toggle the contact sidebar here.
	};

	const handleMenuCloseClick = () => {
		setIsMenuOpen(false);
	};
	

	
	useEffect(() => {
		const handleResize = () => {
			setIsMobileView(window.innerWidth >= 768);
		};

		// Check the screen size on initial render and whenever the window is resized
		handleResize();
		
		window.addEventListener('resize', handleResize);

		// Clean up the event listener on component unmount
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	},[]);
	
	const menuItems = [
		{
			id: 'home',
			name: 'HOME',
			linkName: '#',
		},
		{
			id: 'aboutus',
			name: 'WHO WE ARE',
			linkName: 'about-us'
		},
		{
			id: 'services',
			name: 'SERVICES',
			linkName: '',
			
			subItems: [
				{
					id: 'gmpConsulting',
					displayName: 'GMP Consulting',
					linkName: 'gmp-consulting'
				},
				{
					id: 'manufacturing',
					displayName: 'Manufacturing',
					linkName: 'manufacturing'
				},
				{
					id: 'drugMasterFile',
					displayName: 'Drug Master File',
					linkName: 'drug-master-file'
				},
				{
					id: 'qualityControl',
					displayName: 'Quality Control',
					linkName: 'quality-control'
				},
				{
					id: 'chemicalImpurities',
					displayName: 'Chemical Impurities',
					linkName: 'chemical-impurities'
				},
				{
					id: 'softwareSolution',
					displayName: 'Software Solutions',
					linkName: 'software-solution'
				},
				{
					id: 'humanResource',
					displayName: 'Human Resource',
					linkName: 'human-resource'
				},
				{
					id: 'incorporationMergers',
					displayName: 'New Incorporation Mergers',
					linkName: 'incorporation-mergers'
				},
				{
					id: 'engineering',
					displayName: 'Engineering Services',
					linkName: 'engineering-services'
				},
				{
					id: 'buyerSellers',
					displayName: 'Buyer & Sellers',
					linkName: 'buyer-sellers'
				},
				{
					id: 'facilityProjects',
					displayName: 'New Facility - Projects',
					linkName: 'facility-projects'
				},
				{
					id: 'safety',
					displayName: 'Safety Services',
					linkName: 'safety-services'
				},
			]
		},
		{
			id: 'contactUs',
			name: 'CONTACT US',
			linkName: 'contact-us'
		}
	];
	
	return(
		<header className="header header-transparent rs-nav">
			<Sticky enabled={true} className="sticky-header navbar-expand-lg">
				<div className="menu-bar clearfix">
					<div className="container-fluid clearfix">
						<div className="menu-logo logo-dark">
							<Link to="/"><img src={logo} alt="" width="150"/></Link>
						</div>
						
						<button className={`navbar-toggler collapsed menuicon justify-content-end ${isMenuOpen ? 'open' : ''}`}
							type="button"
							onClick={toggleMenu}
							aria-label="Toggle navigation">
							<span></span>
							<span></span>
							<span></span>
						</button>

						<div className="secondary-menu">
							<ul>
								<li className="num-bx"><a href="tel:(+01)999888777"><i className="fas fa-phone-alt"></i> (+01) 999 888 777</a></li>
								<li className="btn-area"><Link to="/services" className="btn btn-primary shadow">ALL SERVICES <i className="btn-icon-bx fas fa-chevron-right"></i></Link></li>
							</ul>
						</div>
						
						<div className={`menu-links navbar-collapse collapse justify-content-end ${isMenuOpen ? 'show' : ''}`} id="menuDropdown">
							<div className="menu-logo">
								<Link to="/"><img src={logoWhite} alt=""/></Link>
							</div>
							
							<ul className="nav navbar-nav">	
								{menuItems.map((item) => (
									<li
										key={item.id}
											className={`${activeItem === item.id ? 'open' : ''}`}
											onClick={() => !isMobileView && toggleSubmenu(item.id)}
										>
										{item.subItems ? (
											<Link to="#">
												{item.name}
												<i className={`fas fa-plus`}></i>
											</Link>
										) : (
											<Link to={`/${item.linkName}`} onClick={handleMenuLinkClick}>
												{item.name}
											</Link>
										)}
										{(isMobileView || activeItem === item.id) && item.subItems && (
											<ul className={`sub-menu ${item.id === 'services' ? 'two-col' : ''}`}>
												{item.subItems.map((subItem, index) => (
													<li key={subItem.id}><Link to={`/${subItem.linkName}`} onClick={handleMenuLinkClick}><span>{subItem.displayName}</span></Link></li>
												))}
											</ul>
										)}
									</li>
								))}
							</ul>
							
							<ul className="social-media">
								<li><a target="_blank" rel="noreferrer" href="https://www.facebook.com/" className="btn btn-primary"><i className="fab fa-facebook-f"></i></a></li>
								<li><a target="_blank" rel="noreferrer" href="https://www.google.com/" className="btn btn-primary"><i className="fab fa-google"></i></a></li>
								<li><a target="_blank" rel="noreferrer" href="https://www.linkedin.com/" className="btn btn-primary"><i className="fab fa-linkedin-in"></i></a></li>
								<li><a target="_blank" rel="noreferrer" href="https://twitter.com/" className="btn btn-primary"><i className="fab fa-twitter"></i></a></li>
							</ul>
							
							<div className="menu-close" onClick={handleMenuCloseClick}>
								<i className="ti-close"></i>
							</div>
							
						</div>
					</div>
				</div>
			</Sticky>
						
		</header>
	
	);
}

export default Header;